import React from 'react';
import { DropDownFilter } from 'framework/list';
import ComplianceDocumentDropdown from 'domain/compliance/complianceRegistry/shared/inputs/ComplianceDocumentDropdown';

const ComplianceDocumentDropdownFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <ComplianceDocumentDropdown />
    </DropDownFilter>
  );
};

export default ComplianceDocumentDropdownFilter;
